import api from './api';

// 회원 목록 조회
export const getMembers = async (params = {}) => {
  const response = await api.get('/admin/members/', { params });
  return response.data;
};

// 신규 회원 생성
export const createMember = async (memberData) => {
  const response = await api.post('/admin/members/', memberData);
  return response.data;
};

// 회원 상세 조회
export const getMemberDetail = async (memberId) => {
  const response = await api.get(`/admin/members/${memberId}/`);
  return response.data;
};

// 설문지 내용 조회
export const getMemberSurvey = async (memberId, taxYear = null) => {
  const params = {};
  if (taxYear) params.tax_year = taxYear;
  const response = await api.get(`/admin/members/${memberId}/survey/`, { params });
  return response.data;
};

// Excel 다운로드
export const downloadExcel = async (params = {}) => {
  const response = await api.get('/admin/export/excel/', {
    params,
    responseType: 'blob',
  });
  return response.data;
};

// 파일 다운로드
export const downloadFile = async (fileId) => {
  const response = await api.get(`/admin/files/${fileId}/download/`, {
    responseType: 'blob',
  });
  return response.data;
};

// 파일 압축 다운로드 (개별/일괄)
export const downloadFilesZip = async (memberIds) => {
  const response = await api.post('/admin/files/download-zip/', {
    member_ids: memberIds,
  }, {
    responseType: 'blob',
  });
  return response.data;
};

// Template 다운로드
export const downloadMemberTemplate = async () => {
  const response = await api.get('/admin/members/template/', {
    responseType: 'blob',
  });
  return response.data;
};

// 회원 일괄 업로드
export const bulkCreateMembers = async (file, sendInvite = false) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('send_invite', sendInvite);
  const response = await api.post('/admin/members/bulk-create/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// 초대 메일 발송
export const sendInviteEmails = async (memberIds) => {
  const response = await api.post('/admin/members/send-invite-emails/', {
    member_ids: memberIds,
  });
  return response.data;
};

// 비밀번호 재발송
export const sendPasswordReset = async (memberIds) => {
  const response = await api.post('/admin/members/send-password-reset/', {
    member_ids: memberIds,
  });
  return response.data;
};

// 회원 삭제 (선택)
export const deleteMembers = async (memberIds) => {
  const response = await api.post('/admin/members/bulk-delete/', {
    member_ids: memberIds,
  });
  return response.data;
};

// 이메일 발송 이력 조회
export const getEmailLogs = async (memberId) => {
  const response = await api.get(`/admin/members/${memberId}/email-logs/`);
  return response.data;
};

// 과세연도 일괄 전환
export const taxYearBulkTransition = async (memberIds, newTaxYear) => {
  const response = await api.post('/admin/tax-year-bulk-transition/', {
    member_ids: memberIds,
    new_tax_year: newTaxYear,
  });
  return response.data;
};

// 과세연도 데이터 삭제
export const taxYearDataDelete = async (memberIds, taxYear) => {
  const response = await api.post('/admin/tax-year-data-delete/', {
    member_ids: memberIds,
    tax_year: taxYear,
  });
  return response.data;
};

// 회원 상태 변경
export const updateMemberStatus = async (memberId, status) => {
  const response = await api.patch(`/admin/members/${memberId}/`, {
    status,
  });
  return response.data;
};

// 개별 초대 메일 발송
export const sendInviteEmail = async (memberId) => {
  const response = await api.post(`/admin/members/${memberId}/send-invite/`);
  return response.data;
};

// 개별 비밀번호 재설정 및 발송
export const sendPasswordResetEmail = async (memberId) => {
  const response = await api.post(`/admin/members/${memberId}/send-password-reset/`);
  return response.data;
};

